import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_freight_billing_header_storageService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { payload?: $frontendTypes.Invoices.FreightBillingHeader[], action: string, skip?: number, take?: number, date_from?: string, date_to?: string, full_text_search?: string }): Promise<{ payload?: $frontendTypes.Invoices.FreightBillingHeader[], success?: boolean, error?: any[], count?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.action)) {
      $missingRequiredInParams.push('\'action\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

